@if (aberto()) {
  @if (modo() === 'historico') {
    <app-modal [isOpen]="aberto()" size="lg" icone="history" (closeModal)="fechar()">
      <app-modal-header>Histórico de versões</app-modal-header>

      <!-- A rolagem é a do corpo da modal (até 90vh), e não uma segunda rolagem aqui
           dentro: com duas, o conteúdo ficava preso em 60vh e sobrava barra dupla. -->
      <div modalBody>
        @if (mostrarSeletorPlataforma()) {
          <!-- Web e app têm linhas de versão independentes: o histórico é um por
               plataforma. As abas ficam coladas no topo, porque a lista é longa. -->
          <div
            class="sticky -top-5 z-10 -mx-6 -mt-5 mb-5 flex items-center gap-2 border-b border-border-primary bg-white px-6 pb-3 pt-5"
            role="tablist"
            aria-label="Plataforma do histórico"
          >
            @for (aba of abasHistorico; track aba.plataforma) {
              <button
                type="button"
                role="tab"
                [attr.aria-selected]="plataformaHistorico() === aba.plataforma"
                (click)="trocarPlataforma(aba.plataforma)"
                class="flex h-8 items-center gap-1.5 rounded-lg border px-3 text-sm transition-colors"
                [class.border-color-brand]="plataformaHistorico() === aba.plataforma"
                [class.text-color-brand]="plataformaHistorico() === aba.plataforma"
                [class.font-semibold]="plataformaHistorico() === aba.plataforma"
                [class.border-border-primary]="plataformaHistorico() !== aba.plataforma"
                [class.text-content-secondary]="plataformaHistorico() !== aba.plataforma"
              >
                <app-icon [name]="aba.icone" size="16" />
                {{ aba.titulo }}
              </button>
            }
          </div>
        }

        @if (historicoAtual().length) {
          <div class="flex flex-col">
            @for (item of historicoAtual(); track item.versao) {
              <!-- Uma versão por bloco, separada por uma linha fina: o histórico é
                   uma sequência de entregas, não uma lista contínua de itens. -->
              <div class="flex flex-col gap-3 border-b border-gray-100 py-5 first:pt-0 last:border-0 last:pb-0">
                <div class="flex items-center gap-2.5">
                  <h3
                    class="inline-block shrink-0 rounded-full bg-color-brand/10 px-2.5 py-0.5 text-xs font-semibold text-color-brand"
                    [title]="'Versão ' + item.versao"
                  >
                    Versão {{ item.versao }}
                  </h3>
                  <span class="text-xs text-content-tertiary">{{ item.publicadoEm | date: 'dd/MM/yyyy' }}</span>
                </div>

                @if (item.markdown) {
                  <app-notas-markdown [markdown]="item.markdown" />
                } @else {
                  <app-notas-da-versao [notas]="item.notas" />
                }
              </div>
            }
          </div>
        } @else {
          <p class="text-sm text-content-secondary">Nenhuma versão registrada ainda.</p>
        }
      </div>

      <app-modal-footer>
        <div class="flex w-full justify-end">
          <button type="button" appButton size="xs" (click)="fechar()">Entendi</button>
        </div>
      </app-modal-footer>
    </app-modal>
  } @else {
    <app-modal
      [isOpen]="aberto()"
      size="lg"
      icone="checkmark_badge_01"
      [descricao]="descricao()"
      (closeModal)="fechar()"
    >
      <app-modal-header>Novidades desta versão</app-modal-header>

      <div modalBody>
        <!-- Um bloco por plataforma com novidade: só entra aqui o que tem o que dizer. -->
        <div class="flex flex-col gap-7">
          @for (bloco of blocos(); track bloco.plataforma) {
            <section class="flex flex-col gap-4" [attr.data-plataforma]="bloco.plataforma">
              <header class="flex items-center gap-2 border-b border-border-primary pb-2.5">
                <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-color-brand/10">
                  <app-icon [name]="bloco.icone" size="14" class="text-color-brand" />
                </span>
                <h3 class="text-sm font-semibold text-content-primary">{{ bloco.titulo }}</h3>
                <span class="hidden truncate text-xs text-content-tertiary sm:inline">{{ bloco.complemento }}</span>
                <span
                  class="ml-auto inline-block shrink-0 rounded-full bg-color-brand/10 px-2.5 py-0.5 text-xs font-semibold text-color-brand"
                  [title]="'Versão ' + bloco.versao"
                >
                  Versão {{ bloco.versao }}
                </span>
              </header>

              @if (bloco.markdown) {
                <app-notas-markdown [markdown]="bloco.markdown" />
              } @else {
                <app-notas-da-versao [notas]="bloco.notas" />
              }
            </section>
          }
        </div>
      </div>

      <app-modal-footer>
        <div class="flex w-full items-center justify-between gap-3">
          <app-checkbox [(ngModel)]="naoMostrarNovamente" label="Não mostrar novamente" />
          <button type="button" appButton size="xs" (click)="fechar()">Entendi</button>
        </div>
      </app-modal-footer>
    </app-modal>
  }
}
